import { Field } from "@sitecore-jss/sitecore-jss-react";
import React from "react";

import { V23 } from "../../../components/InputFields/sanitizer/inputSanitizers";
import TextInput from "../../../components/InputFields/TextInput";
import { V1, V5, V10 } from "../../../components/InputFields/validator/validators";
import { PolicyNumberSearchData } from "../searchDupDlpPolicy/SearchDupDlpPolicy.state";
import styles from "./SearchByPolicyNumberFields.module.scss";

interface Props {
  fields: Record<string, Field<string>>;
  handleUpdatePolicyNumber: (data: Partial<PolicyNumberSearchData>) => void;
  values: Partial<PolicyNumberSearchData>;
}

export const SearchByPolicyNumberFields = ({ fields, handleUpdatePolicyNumber, values }: Props) => {
  const onChangePolicyNumber = (policyNumber: string) => {
    handleUpdatePolicyNumber({ policyNumber });
  };

  return (
    <div className={styles.searchByPolicyNumberFields__wrapper}>
      <TextInput
        fieldData={fields}
        name="PolicyNumber"
        fieldName="PolicyNumber"
        sanitize={[V23]}
        validators={[V1, V5, V10(10)]}
        propertyName="PolicyNumber"
        onBlur={onChangePolicyNumber}
        excludeRow={true}
        inputValue={values.policyNumber}
        required
      />
    </div>
  );
};
